var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c('g', {
    attrs: {
      "fill-rule": "nonzero"
    }
  }, [_c('path', {
    attrs: {
      "d": "M10.236 8.618A4.623 4.623 0 0 0 5.618 4 4.623 4.623 0 0 0 1 8.618c0 .746.178 1.451.494 2.076l4.124 8.504 4.125-8.506a4.588 4.588 0 0 0 .493-2.074zm-4.618 2.555a2.558 2.558 0 0 1-2.556-2.555 2.558 2.558 0 0 1 2.556-2.556 2.558 2.558 0 0 1 2.555 2.556 2.558 2.558 0 0 1-2.555 2.555zM19.69 4.4a2.808 2.808 0 0 0-2.504 4.065l2.504 5.166 2.505-5.166c.192-.38.3-.808.3-1.26A2.808 2.808 0 0 0 19.69 4.4zm0 4.357a1.554 1.554 0 0 1-1.552-1.552c0-.856.696-1.552 1.552-1.552.856 0 1.552.696 1.552 1.552 0 .855-.696 1.552-1.552 1.552zM12.961 12.381a.709.709 0 0 0-.65.4l-.031.064-1.946 4.034-2.182-.048a1 1 0 0 0-.922.564l-.897 1.85 4.696-.103.11-.002a1 1 0 0 0 .933-.704l.002-.006 1.427-4.594 5.46-.138-.572-1.18-5.428-.137z"
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }